import Axios from "../config/axios-v1-config";

/**
 * API helpers for the helpdesk contacts feature: contact CRUD, commerce
 * lookup/search, and per-conversation commerce override.
 *
 * The backend lives in microservice-conversations under `/helpdesk/*`,
 * accessed through bff-auth-gateway which injects the authenticated user's
 * logistic company into request headers — so we never pass a tenant id.
 */

// ─── Contacts ─────────────────────────────────────────────────────────────

export async function getHelpdeskContacts({ q, commerce_id, limit, offset } = {}) {
  try {
    const response = await Axios.get("helpdesk/contacts", {
      params: {
        q: q || undefined,
        commerce_id: commerce_id || undefined,
        limit,
        offset,
      },
    });
    return response.data;
  } catch (err) {
    return { error: err.response?.data?.message || err.response?.data || "Error desconocido" };
  }
}

export async function getHelpdeskContact(id) {
  try {
    const response = await Axios.get(`helpdesk/contacts/${id}`);
    return response.data;
  } catch (err) {
    return { error: err.response?.data?.message || err.response?.data || "Error desconocido" };
  }
}

export async function updateHelpdeskContact(id, patch) {
  try {
    const response = await Axios.patch(`helpdesk/contacts/${id}`, patch);
    return response.data;
  } catch (err) {
    return { error: err.response?.data?.message || err.response?.data || "Error desconocido" };
  }
}

export async function refreshContactLookup(id) {
  try {
    const response = await Axios.post(`helpdesk/contacts/${id}/refresh-lookup`);
    return response.data;
  } catch (err) {
    return { error: err.response?.data?.message || err.response?.data || "Error desconocido" };
  }
}

// ─── Conversation commerce override ──────────────────────────────────────

/**
 * Set the per-conversation commerce override (or pass null/empty to clear it,
 * letting it fall back to the contact's default).
 *
 * El tercer argumento es opcional: sin él la request sale igual que antes
 * (timeout global de 60 s, sin cancelación). El panel de incidencias pasa su
 * timeout de 15 s para no dejar "Asignando…" colgado hasta un minuto.
 * @param {string} conversationId
 * @param {string|null} commerceId
 * @param {{timeoutMs?: number, signal?: AbortSignal}} [options]
 */
export async function setConversationCommerce(conversationId, commerceId, { timeoutMs, signal } = {}) {
  try {
    const response = await Axios.patch(
      `conversations/${conversationId}/commerce`,
      { commerce_id: commerceId || null },
      {
        ...(Number.isFinite(timeoutMs) && timeoutMs > 0 && { timeout: timeoutMs }),
        ...(signal && { signal }),
      },
    );
    return response.data;
  } catch (err) {
    return { error: err.response?.data?.message || "Error desconocido" };
  }
}
